/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Button, FlexContainer, Text, theme } from "@nordcloud/gnui";
import { KeyValue } from "~/generated/graphql";
import { isObject } from "~/tools";

const StyledListItem = styled.li`
  padding: ${theme.spacing.spacing01} ${theme.spacing.spacing01}
    ${theme.spacing.spacing01} 0;
  border-radius: ${theme.radius.md};
  transition: ${theme.transition};
  span {
    min-width: 1.5rem;
    text-align: right;
  }

  button {
    transition: ${theme.transition};
    opacity: 0;
  }

  &:hover {
    background: ${theme.color.background.ui04};

    button {
      opacity: 1;
    }
  }
`;

const EMPTY_SPACE = 28;
const MARGIN = 8;

export type ListItemValueProps = {
  label: string;
  value: KeyValue | string;
  onClick: () => void;
};

export function ListItemValue({ label, value, onClick }: ListItemValueProps) {
  return (
    <StyledListItem data-testid="rule-match">
      <FlexContainer justifyContent="space-between">
        <FlexContainer
          css={{
            maxWidth: `calc(100% - ${EMPTY_SPACE}px)`,
            width: "100%",
          }}
        >
          <Text
            color={theme.color.text.text02}
            tag="span"
            mr={theme.spacing.spacing02}
            lineHeight="2rem"
          >
            {label}
          </Text>
          <div
            css={{
              maxWidth: `calc(100% - ${EMPTY_SPACE + MARGIN}px)`,
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {isObject(value) ? `${value.key}: ${value.value}` : value}
          </div>
        </FlexContainer>
        <Button icon="trash" size="md" severity="low" onClick={onClick} />
      </FlexContainer>
    </StyledListItem>
  );
}
